<template>
    <div>
        <div class="form-header">
            <h2 class="form-step ppv2-text-black" :style="{ fontSize: sizes.formStep }">
                {{ $t('serie.step_label') }} {{ step.id }}
            </h2>
            <h1 class="step_title_content text-left ppv2-text-black" :style="{ fontSize: sizes.title }">
                {{ step.id === 1 ? step.content : step.subtitle }}
            </h1>

            <p
                class="ppv2-text-black poppinsRegular !ppv2-mb-0"
                :style="{ fontSize: normalizeFontSize(14), marginTop: normalizeSizeVertical(36, true) }"
                v-if="step.content && step.id !== 1"
            >
                {{ step.content }}
            </p>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'SerieHeaderStep',
    methods: {
        normalizeSizeVertical,
        normalizeSize,
        normalizeFontSize,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
    },
}
</script>

<style scoped>
.step_title_content {
    font-family: 'Poppins Light', sans-serif !important;
    margin-bottom: 0 !important;
}
.form-header {
    margin-bottom: 40px;
}
.form-step {
    text-transform: uppercase;
    margin-bottom: 6px;
}
</style>
